"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  unknownCadastralCode: 'cadastral number unknown',
  goToPayment: 'proceed to payment'
};